import { getUtilityInvoiceSettlement } from "./utilitySettlement"

// Small presentational helpers shared across the UT Bills module screens.

// A provider can be a native standalone UtilityProvider or an FRP
// ManagementCompany surfaced through the bridge. The badge makes the source
// obvious while both behave identically in the UI.
export function getProviderSourceMeta(source) {
  if (source === "management_company") {
    return {
      label: "FRP Company",
      icon: "building-fill",
      className: "border-indigo-200 bg-indigo-50 text-indigo-700",
    }
  }
  return {
    label: "Provider",
    icon: "shop",
    className: "border-teal-200 bg-teal-50 text-teal-700",
  }
}

export function getProviderEntityTypeLabel(entityType) {
  if (entityType === "individual") return "Individual"
  if (entityType === "business") return "Business (SMEs)"
  return "Company (LLC/LTD)"
}

export function getProviderRegistrationSummary(provider) {
  if (provider?.entityType === "individual") {
    return provider?.alsoKnownAs ? `A.K.A ${provider.alsoKnownAs}` : "Individual registration"
  }

  if (provider?.entityType === "business") {
    const businessLocation = [
      provider?.businessCityTown,
      provider?.businessLocation || provider?.location,
      provider?.businessArea,
    ].filter(Boolean).join(", ")
    return [provider?.businessType, businessLocation]
      .filter(Boolean)
      .join(" · ") || "Business (SMEs)"
  }

  return [provider?.telephoneNumber || "No telephone", provider?.location]
    .filter(Boolean)
    .join(" · ")
}

// Up to two letters for the round avatar shown next to a customer name.
export function getCustomerInitials(name) {
  return (
    String(name || "")
      .trim()
      .split(/\s+/)
      .slice(0, 2)
      .map((part) => part[0] || "")
      .join("")
      .toUpperCase() || "?"
  )
}

// Customer-facing bills come from standalone UT bills or legacy FRP unit utilities.
export function getInvoiceSourceMeta(source) {
  if (source === "frp_utility") {
    return { label: "FRP Utility", className: "border-violet-200 bg-violet-50 text-violet-700" }
  }
  return { label: "UT Bill", className: "border-teal-200 bg-teal-50 text-teal-700" }
}

export function getBillStatusMeta(invoice) {
  const settlement = getUtilityInvoiceSettlement(invoice)
  if (settlement.settlementStatus === "paid") {
    return { label: "Paid", icon: "check-circle-fill", className: "border-emerald-200 bg-emerald-50 text-emerald-700", textClassName: "text-emerald-700", isOverdue: false }
  }
  if (settlement.settlementStatus === "partial") {
    return { label: "Partial", icon: "hourglass-split", className: "border-amber-200 bg-amber-50 text-amber-700", textClassName: "text-amber-700", isOverdue: settlement.isOverdue }
  }
  return { label: "Unpaid", icon: "exclamation-circle-fill", className: "border-red-200 bg-red-50 text-red-700", textClassName: "text-red-600", isOverdue: settlement.isOverdue }
}

export function getBillTypeMeta(billType) {
  if (billType === "water") return { label: "Water", icon: "droplet-fill", className: "text-sky-600" }
  if (billType === "trash") return { label: "Trash", icon: "trash3-fill", className: "text-amber-600" }
  return { label: "Other", icon: "receipt", className: "text-slate-500" }
}

export function getIncomeSourceMeta(source) {
  if (source === "frp_water_bridge") {
    return {
      label: "FRP",
      icon: "building-fill",
      className: "border-violet-200 bg-violet-50 text-violet-700",
    }
  }
  return {
    label: "UT",
    icon: "wallet2",
    className: "border-teal-200 bg-teal-50 text-teal-700",
  }
}
